import PrintLabel from '@/store/modules/printLabel/constants';

export default {
  [PrintLabel.getters.getError](state) {
    return state.error;
  },

  [PrintLabel.getters.isLoading](state) {
    return state.loading;
  },

  [PrintLabel.getters.getPrintLabelInfo](state) {
    const data = state.printLabelInfo;

    if (!data) {
      return null;
    }

    let result = {
      from: data.from,
      to: data.to,
      poNumber: data.poNumber,
    };

    if (data.skus) {
      const total = data.skus.reduce((acc, sku) => acc + sku.boxes.length, 0);
      let caseNumber = 1;
      const boxes = data.skus.reduce((acc, sku) => {
        sku.boxes.forEach((box) => {
          sku.skuInfo.forEach((info) => {
            acc.push({
              sku: info.sku,
              description: info.description,
              number: caseNumber,
              total,
              ...box,
            });
          });
          caseNumber += 1;
        });

        return acc;
      }, []);

      result = {
        ...result,
        boxes,
      };
    }
    return result;
  },
};
